
import React, {useState} from "react";
import Contacts from "./Contacts";

import {useEffect} from "react";

import {useNavigate} from "react-router-dom";



import "bootstrap/dist/css/bootstrap.css";
import "formiojs/dist/formio.full.min.css";

import {Form} from "@formio/react";
import form from "../forms/passwords-forms.json";
import { useAuth } from "react-oidc-context";
import {Link} from "react-router-dom";


// Basic inline styles for immediate use
const styles = {
    container: {
        maxWidth: "400px",
        margin: "40px auto",
        padding: "20px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        fontFamily: "sans-serif",
        backgroundColor: "#f9f9f9",
    },
    displayGroup: {
        display: "flex",
        gap: "10px",
        marginBottom: "20px",
    },
    passwordInput: {
        flex: 1,
        padding: "10px",
        fontSize: "16px",
        borderRadius: "4px",
        border: "1px solid #ccc",
        backgroundColor: "#fff",
    },
    copyBtn: {
        padding: "10px 15px",
        fontSize: "16px",
        cursor: "pointer",
        backgroundColor: "#007bff",
        color: "#fff",
        border: "none",
        borderRadius: "4px",
    },
    controls: {
        display: "flex",
        flexDirection: "column",
        gap: "15px",
    },
    range: {
        width: "100%",
        marginTop: "5px",
    },
    checkboxGroup: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "10px",
    },
    generateBtn: {
        padding: "12px",
        fontSize: "16px",
        cursor: "pointer",
        backgroundColor: "#28a745",
        color: "#fff",
        border: "none",
        borderRadius: "4px",
    }
};



function Passwords() {

    const auth = useAuth();

    let navigate = useNavigate();

    const username = auth.user?.profile.preferred_username



    const [passwordLDAP, setPasswordLDAP] = useState("");

    const [passwordAD, setPasswordAD] = useState("");
    const [length, setLength] = useState(14);
    const [useUpper, setUseUpper] = useState(true);
    const [useLower, setUseLower] = useState(true);
    const [useNumbers, setUseNumbers] = useState(true);
    const [useSymbols, setUseSymbols] = useState(true);
    const [copied, setCopied] = useState(false);

    const [passwordNET, setPasswordNET] = useState("");

    const [formState, setFormState] = useState("clear");

    const [message, setMessage] = useState("");

    const defaultSubmission = {
        data: 'sdsds'
    }


    const generatePasswordTXT = (length = 20) =>    {
        const upper = "ABCDEFGHJKLMNPQRSTUVWXYZ";
        const lower = "abcdefghijkmnopqrstuvwxyz";
        const digits = "23456789";
        const symbols = "!@#$%^&*-_=+?";
        const all = upper + lower + digits + symbols;

        const pick = (chars) =>
            chars[Math.floor(crypto.getRandomValues(new Uint32Array(1))[0] / 2 ** 32 * chars.length)];

        const required = [
            pick(upper),
            pick(lower),
            pick(digits),
            pick(symbols),
        ];

        while (required.length < length) {
            required.push(pick(all));
        }

        return required
            .sort(() => crypto.getRandomValues(new Uint32Array(1))[0] - 2 ** 31)
            .join("");
    }

    const generatePassword = () => {


        const generated = generatePasswordTXT(length);

        setPasswordAD(generated);
        setCopied(false);
    };

    const copyToClipboard = () => {
        navigator.clipboard.writeText(passwordAD);
        setCopied(true);
    };


    useEffect(() => {
        generatePassword();
    }, [length, useUpper, useLower, useNumbers, useSymbols]);



    const onFormSubmit = async (e) => {

        const token = auth.user?.access_token;

        const data = e.data
        console.log("submit: for user ::"+username+" :: " + data);
        console.log("submit: for user ::"+JSON.stringify(auth.user));
        console.log("submit: for user ::"+JSON.stringify(auth.user.profile.preferred_username));
        try {
            setFormState("changing")
            // REACT_APP_MIKE_MIDPOINT_SERVICE_ENDPOINT
            // https://midpoint.fchpt.stuba.sk/schk/api/users/"+{username
            let res = await fetch(process.env.REACT_APP_MIKE_MIDPOINT_SERVICE_ENDPOINT+'users/'+username, {
                method: "PATCH",
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });
            let resJson = await res.json();

            console.log(JSON.stringify(resJson))
            if (res.status === 200) {
                 setPasswordNET("");
                 setPasswordAD("");
                 setPasswordNET("");
                setMessage("Passwords changed successfully");
                navigate("/schk/frontend/selfservice/successfull",{ replace: true });
                setFormState("successfull")
            } else {
                setPasswordNET("");
                setPasswordAD("");
                setPasswordNET("");
                navigate("/schk/frontend/selfservice/failed",{ replace: true });
                setMessage("Passwords was not changed successfully ::" + JSON.stringify(resJson.detail) );
                setFormState("failed")
            }
        } catch (err) {
            console.log(err);
            setFormState("failed")
        }
    }


    const onFormChange = (event) => {
        console.log("MIRO :: CHANGE ::" + event)
    }


    let form = require('../forms/passwords-forms.json');

    console.log("formsttate:: "+formState)

    if (formState  === 'changing') {
        return (

            <div>
                <div class={"message"}>{"Heslo as mení, prosím čakajte, môže to trvať dlhšie"}</div>
            </div>

        )
    }

    // <Link to={process.env.PUBLIC_URL+"/passwords"}>Change Passwords Again ?</Link>



    if (formState === "clear" || true) {
        return (
            <div>
                {(auth.isAuthenticated) ?
                    <>



                                <div><b>Pred tým ako zmeníte heslo stlačením tlačidla "Change password" , si ho nakopírujte na bezpečne miesto, po zmene hesla už nebude viditeľné.</b></div>


                                    <span></span><br></br>

                                    <div style={styles.displayGroup}>
                                        <input
                                            type="text"
                                            value={passwordAD}
                                            readOnly
                                            style={styles.passwordInput}
                                        />

                                        <button onClick={copyToClipboard} style={styles.copyBtn}>
                                            {copied ? "Copied!" : "Copy"}
                                        </button>

                                        <button onClick={generatePassword} style={styles.generateBtn}>
                                            Generate
                                        </button>

                                        <button onClick={ (event) => onFormSubmit(
                                            {data:{
                                                    passwordAD: passwordAD ,
                                                    passwordLDAP: passwordLDAP,
                                                    passwordNET: passwordNET,
                                                    password:passwordAD,

                                                    fchptNETPasswordSameAsPassword: true,
                                                    fchptADPasswordSameAsPassword: true,
                                                    fchptLDAPPasswordSameAsPassword: true,
                                            }
                                            }
                                        ) } style={styles.resetBtn}>
                                            Change password
                                        </button>
                                    </div>


                    </>
                    :  <div>Pre zmenu hesla sa prihláste</div>
                }
            </div>

        )
    }



}

export default Passwords;
